import { useExperimentContext } from "components/ExperimentProvider"
import { getClient } from "lib/apolloClient"
import { Logger } from "lib/logger"
import { useSearchParams } from "next/navigation"
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed"
import getContentfulEnvironment from "utils/get-contentful-environment"
import { MULTI_PROMO } from "../shared/graphql/multiPromo.graphql"

const multiPromoTrackingMap = {
  pdp: 0,
  landingPage: 1,
  pinnedPlp: 2,
  nmhp: 3,
}

const log = Logger("useMultiPromoTracking")

export const useMultiPromoTracking = (): void => {
  const searchParams = useSearchParams()
  const multiPromoSlug = searchParams.get("multiPromo")
  const { getValue } = useExperimentContext()
  const trackExperimentViewed = useExperimentViewed()

  if (!multiPromoSlug) {
    return
  }

  const run = async () => {
    const branchName = await getContentfulEnvironment()
    try {
      const {
        data: { getMultiPromo },
      } = await getClient().query({
        query: MULTI_PROMO,
        variables: { slug: multiPromoSlug, branchName },
      })

      const experimentValue = getValue(getMultiPromo.experimentId) as string

      if (!experimentValue) {
        log.error(
          `No experiment value found for ${getMultiPromo.experimentId} flag`
        )
        return
      }

      trackExperimentViewed(
        getMultiPromo.experimentId,
        multiPromoTrackingMap[experimentValue]
      )
    } catch (err) {
      log.warn({ err }, "Failed to fetch mutli promo from contentful")
    }
  }

  run()
}
